import React from "react";
import SwitchInput from "../../../core/form/SwitchInput";

let ResourceEnabledField = (props) => {

    return <SwitchInput
        name='enabled'
        label='form.resource.enabled'
        required={false}
        {...props}
    />
}

export default ResourceEnabledField